import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  Button,
  useTheme,
} from "@mui/material";

import WhatsApp from '@mui/icons-material/WhatsApp';
import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import Mail from '@mui/icons-material/Email';
import PhoneCall from '@mui/icons-material/Phone';
import Smartphone from '@mui/icons-material/AppShortcut';
import Globe from '@mui/icons-material/Language';
import CheckCircle from '@mui/icons-material/CheckCircle';

const canaisDisponiveis = [
  {
    key: "whatsapp",
    label: "WhatsApp",
    description: "Canal direto com o cliente mais usado no Brasil",
    icon: <WhatsApp sx={{ color: "#25D366" }} />,
  },
  {
    key: "messenger",
    label: "Messenger",
    description: "Solicitações pelo Facebook",
    icon: <Facebook sx={{ color: "#1877F2" }} />,
  },
  {
    key: "instagram",
    label: "Instagram Direct",
    description: "Atenda mensagens diretas do Instagram",
    icon: <Instagram sx={{ color: "#C13584" }} />,
  },
  {
    key: "email",
    label: "E-mail",
    description: "Responda e-mails com rapidez e controle",
    icon: <Mail />,
  },
  {
    key: "telefone",
    label: "Telefone",
    description: "Integração com telefonia IP",
    icon: <PhoneCall />,
  },
  {
    key: "app",
    label: "App",
    description: "Integre com seu aplicativo móvel",
    icon: <Smartphone />,
  },
  {
    key: "site",
    label: "Site",
    description: "Atenda via chat em seu site",
    icon: <Globe />,
  },
];

const EtapaCanais = ({ canaisSelecionados, setCanaisSelecionados }) => {
  const theme = useTheme();

  const toggleCanal = (key) => {
    setCanaisSelecionados((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  return (
    <Box sx={{ width: "100%"}}>
      <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: theme.palette.primary.main }}>
        🔗 Conectar Canais de Atendimento
      </Typography>

      <Typography variant="body1" gutterBottom>
        Selecione os canais que sua empresa irá utilizar para se comunicar com seus clientes.
      </Typography>

      <Typography variant="body2" color="text.secondary" mb={3}>
        Clique sobre os canais que deseja ativar. Você poderá configurá-los posteriormente.
      </Typography>

      <Grid container spacing={3}>
        {canaisDisponiveis.map((canal) => {
          const isSelected = canaisSelecionados.includes(canal.key);
          return (
            <Grid item xs={12} sm={6} md={4} key={canal.key}>
              <Card
                onClick={() => toggleCanal(canal.key)}
                sx={{
                  borderRadius: 2,
                  border: isSelected ? "2px solid #2196f3" : "1px solid #e0e0e0",
                  backgroundColor: isSelected ? "#e3f2fd" : "#fff",
                  boxShadow: isSelected ? "0 0 0 3px #2196f322" : "none",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  mb: 2,
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  minHeight: 200,
                  p: 3,
                  '&:hover': {
                    boxShadow: 3,
                  },
                }}
              >
                {isSelected && (
                  <CheckCircle
                    fontSize="small"
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      color: "#2196f3",
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                    }}
                  />
                )}

                <Box display="flex" alignItems="center" gap={1} mb={2}>
                  {canal.icon}
                  <Typography variant="h6" fontWeight="bold">
                    {canal.label}
                  </Typography>
                </Box>

                <Typography variant="body2" color="text.secondary" mb={2}>
                  {canal.description}
                </Typography>

                <Box mt="auto">
                  <Button
                    variant="outlined"
                    fullWidth
                    disabled={!isSelected}
                    onClick={(e) => e.stopPropagation()}
                  >
                    Configurar
                  </Button>
                </Box>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Typography variant="caption" color="text.secondary" sx={{ mt: 3, display: "block" }}>
        💬 Esses canais poderão ser utilizados por humanos e bots para atendimento, vendas ou suporte.
      </Typography>
    </Box>
  );
};

export default EtapaCanais;
